module.exports = __webpack_public_path__ + "img/jiQiRen2.67a920fc.png";